import { render } from "./ClaimCoupon.vue?vue&type=template&id=384b3a80"
import script from "./ClaimCoupon.vue?vue&type=script&lang=js"
export * from "./ClaimCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__